import React from "react";
import GuideStyles from "assets/js/guide";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";

export default function GuidetemplateNodata(props) {
  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Template - Nodata</h2>
          </div>

          <h3 className="guide-h3">Type1</h3>
          <div className="nodata">
            <Box className="illust">
              <img src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`} />
            </Box>
            <p className="color-info">조회된 내역이 없습니다</p>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Type2</h3>
          <div className="nodata">
            <Box className="illust" mb={6}>
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/nodata-like.svg`}
              />
            </Box>
            <p>
              <b>찜한 상품이 없습니다</b>
            </p>
            <p className="info-txt">
              장볼 상품을 찜해두고
              <br />
              쇼핑 메모에서 편하게 관리하세요!
            </p>
            <Box mt={5}>
              <Link
                to={"/"}
                className="link-outlined link-primary link-size-small btn-rounded end-icon"
              >
                전단 바로가기
                <i className="ico-go" />
              </Link>
            </Box>
          </div>
        </Box>
      </main>
    </>
  );
}
